"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IP_CANCEL_DISCHARGE_WINDOW_HOURS = void 0;
exports.cancelDischargeDeadline = cancelDischargeDeadline;
exports.isWithinCancelDischargeWindow = isWithinCancelDischargeWindow;
/**
 * CANCEL DISCHARGE — the window in which a discharged IP stay may be reopened.
 *
 * Desk, 2026-09-25: "this Cancel Discharge valid upto 48 hours of advise
 * discharge clicked."
 *
 * ONE DEFINITION, read by the server (which enforces it) and by the workstation
 * (which only decides whether to OFFER the button) — so the screen cannot show a
 * control the server will refuse for a reason the screen could have known.
 *
 * MEASURED FROM `dischargeAdvisedAt`, not from `dischargedAt`. The advice is the
 * click the desk named; `dischargedAt` is an operator-picked date that may be
 * backdated, and a window anchored to a typed date could be widened by typing.
 */
exports.IP_CANCEL_DISCHARGE_WINDOW_HOURS = 48;
const HOUR_MS = 60 * 60 * 1000;
/** The instant the window closes, or null when the advice time was never recorded. */
function cancelDischargeDeadline(advisedAt) {
    if (!advisedAt)
        return null;
    const at = advisedAt instanceof Date ? advisedAt : new Date(advisedAt);
    if (Number.isNaN(at.getTime()))
        return null;
    return new Date(at.getTime() + exports.IP_CANCEL_DISCHARGE_WINDOW_HOURS * HOUR_MS);
}
/**
 * True while a discharge may still be cancelled. An unrecorded advice time is
 * NOT inside the window: the rule cannot be shown to hold, so it does not.
 * Exactly at the deadline is still inside (only strictly later is refused).
 */
function isWithinCancelDischargeWindow(advisedAt, now = new Date()) {
    const deadline = cancelDischargeDeadline(advisedAt);
    return deadline !== null && now.getTime() <= deadline.getTime();
}
//# sourceMappingURL=ip-cancel-discharge.js.map